import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { deductionSchemaObject } from '../../Data'
import { Fields, validateProperty, validate, Card } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi'
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import MaterialTable from 'material-table';
import Grid from '@material-ui/core/Grid';
import { CommonDecryptParam } from '../../../../utils/CommonParams';
import { Data } from '@react-google-maps/api';

const screenCode = 'DEDUCTIONTEMPLATE';

export function DeductionAddEdit(props) {

    const { data, edit } = props.location
    const [pageProperties, setPageProperties] = useState({
        title: 'Add Deduction Template',
        buttonText: 'Save'
    })
    const [groups, setGroups] = useState()
    const [collectionPoint, setCollectionPoint] = useState();
    const [factoriesData, setFactoriesData] = useState()
    const [entityType, setEntityType] = useState()
    const [isDropdownDisable, setIsDropdownDisable] = useState(false);

    const [deductionType, setDeductionType] = useState();
    const [applyMethods, setApplyMethods] = useState();

    const [deduction, setDeduction] = useState({
        deductionTemplateID: '0',
        groupID: 0,
        groupName: '',
        operationEntityID: 0,
        factoryName: '',
        collectionPointID: 0,
        collectionCategoryMenuID: 0,
        collectionPointName: '',
        deductionTypeID: 0,
        deductionTypeName: '',
        applyMethodID: '0',
        collectionCategoryID: '',
        defaultValue: 0,
        minimumValue: 0,
        isFixed:false,
        isActive: true,
        isDefaultValueEnabled: false,
        createdBy: '',
        createdDate: '',
        entityTypeID: 0,
        fixedDeductions:[],
        deductionOrder: '',
        deductionSequence: ''


    });
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const [collectionCategoryMenus, setCollectionCategoryMenus] = useState([]);

    const [deletedValues, setDeletedValues] = useState({
        deleted : []
    });

    const schema = Joi.object(deductionSchemaObject).options({ allowUnknown: true });


    const [state, setState] = useState({
        columns: [
          { title: 'Deduction Type', field: 'name' },
          { title: 'Value', field: 'value', type: 'numeric' },
        ],
        data: [],
      });

    const encriptedTest = props.match.params["id"];
    const id = (encriptedTest !== undefined) ? CommonDecryptParam(props.match.params["id"]) : 0;

    useEffect(() => {
       
        trackPromise(
            setEntityTypeDropDown()
        )

        trackPromise(
            setApplyMethodsData()
        )


    }, []);

    useEffect(() => {
        getPermissions()
        
    }, []);

    useEffect(() => {
        if (deduction.groupID != 0) {
            trackPromise(
                getOperationEntitiesForDropdown()
            )
        }
    }, [deduction.groupID]);

    useEffect(() => {
        trackPromise(
            CollectionPointsByOperationEntity()
        )
    }, [deduction.operationEntityID]);

    useEffect(() => {
        trackPromise(
            CollectionCategoryMenusForDropdown()
        )
    }, [deduction.collectionPointID]);

    useEffect(() => {
        trackPromise(
            getAvailableDeductionTypes()
        )
    }, [deduction.collectionCategoryMenuID]);

    async function getDeductionData(){
        const result = await services.getDeductionDataForAddEdit(id);
        return result;
    }

     async function maptoFixedDeduction(){
        var fixedDeductionsArray=[];
        var id = tokenService.getUserIDFromToken();
        state.data.map((item)=>{
            let data={
                fixedDeductionID :0,
                name :item.name,
                value :parseFloat(item.value),
                isActive :true,
                createdBy :parseInt(id)
            }
            fixedDeductionsArray.push(data);
        })
       
       return fixedDeductionsArray;
    }

    async function maptoFixedDeductionForEdit(){
        var fixedDeductionsArray=[];
        var id = tokenService.getUserIDFromToken();
        state.data.map((item)=>{
            if(item.fixedDeductionID === undefined || item.fixedDeductionID == null){
                let data={
                    fixedDeductionID :0,
                    name :item.name,
                    value :parseFloat(item.value),
                    isActive :true,
                    createdBy :parseInt(id)
                }
                fixedDeductionsArray.push(data);
            }else{
                let data={
                    fixedDeductionID :item.fixedDeductionID,
                    name :item.name,
                    value :parseFloat(item.value),
                    isActive :true,
                    createdBy :parseInt(id)
                }
                fixedDeductionsArray.push(data);
            }
            
           
        })

        deletedValues.deleted.map((item)=>{
            if(item.fixedDeductionID != undefined || item.fixedDeductionID != null){
                let data={
                    fixedDeductionID :item.fixedDeductionID,
                    name :item.name,
                    value :parseFloat(item.value),
                    isActive :false,
                    createdBy :parseInt(id)
                }
                fixedDeductionsArray.push(data);
            }
            
           
        })
      
       return fixedDeductionsArray;
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITDEDUCTIONTEMPLATE');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        if (data && edit) {
            setPageProperties({
                title: 'Edit Deduction',
                buttonText: 'Update'
            })
            const newdata = await getDeductionData();
            setDeduction(newdata);
            setState({
                ...state,
                data: newdata.fixedDeductions
            })
            setIsDropdownDisable(true);
        } else {
            setPageProperties({
                title: 'Add Deduction',
                buttonText: 'Save'
            });

            var token = tokenService.getUserDetailsFromToken();
            setDeduction({
                ...deduction,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        trackPromise(
            setGroupDropDownData(),
            setEntityTypeDropDown(),
            setApplyMethodsData()
        )

    }

    async function CollectionPointsByOperationEntity() {
        let filteredData = await services.getCollectionPointByOperationEntityId(deduction.groupID, deduction.operationEntityID);

        setCollectionPoint(filteredData)
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.getAllOperationEntitiesForDropDown(deduction.groupID);
        setFactoriesData(opEntities);
    }

    async function CollectionCategoryMenusForDropdown(){
        const result = await services.getCollectionCategoryMenusForDropdown(deduction.collectionPointID);
        setCollectionCategoryMenus(result);
    }

     function handleChange(e) {
         const target = e.target

         const value = target.type === 'checkbox' ? target.checked : target.value
        
         setDeduction({
             ...deduction,
             [e.target.name]: value
           
        })
        

     }
    
    //  function handleChange(e) {
    //      const target = e.target

    //     const value = target.name === 'checkbox' ? target.checked : target.value

    //     const error = { ...errors }
    //      const errorMessage = validateProperty(target, deductionSchemaObject)
    //      errorMessage ? error[target.name] = errorMessage : delete error[target.name]

    //      setDeduction({
    //          ...deduction,
    //          [e.target.name]: value
    //      })
    //      setErrors(error)
    //  }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, deductionSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setDeduction({
            ...deduction,
            groupID: target.value,
            operationEntityID: '0',
            collectionPointID: '0'
        });
    }

    function handleOperationEntityChange(target) {

        validateInputs(target);

        setDeduction({
            ...deduction,
            operationEntityID: target.value,
            collectionPointID: '0'
        });
    }

    function handleCollectionPointChange(target) {

        validateInputs(target);

        setDeduction({
            ...deduction,
            collectionPointID: target.value,
            deductionTypeID: '0'
        });
    }
    async function handleCollectionCategoryMenuChange(target){
        validateInputs(target);

        setDeduction({
            ...deduction,
            collectionCategoryMenuID: target.value,
        });
    }

    async function handleSpecialDeductionChange(e){
        const target = e.target

        const value = target.type === 'checkbox' ? target.checked : target.value

        
        if(target.name === "isDefaultValueEnabled"){
            if(value){
                setDeduction({
                    ...deduction,
                    [e.target.name]: value,
                    "isFixed" : false,
                    "isDefaultValueEnabled": true
                })  
            }
            else{
                setDeduction({
                    ...deduction,
                    [e.target.name]: value,
                    "isDefaultValueEnabled": false
                })
            }  
        }
        else{

            if(value){
                setDeduction({
                    ...deduction,
                    [e.target.name]: value,
                      "isFixed" : true,
                      "isDefaultValueEnabled": false
                    }) 
            }
            else{
                setDeduction({
                    ...deduction,
                    [e.target.name]: value,
                      "isFixed" : false,
                    })
            }

            
        }

    }

    
                    
    async function getAvailableDeductionTypes() {

        let filteredData = await services.getAvailableDeductionTypes(deduction.groupID, deduction.operationEntityID, deduction.collectionPointID, deduction.deductionTemplateID, deduction.collectionCategoryMenuID);
        setDeductionType(filteredData)
    }


    function handleSave(e) {
        e.preventDefault()
        maptoFixedDeduction();
        const target = e.target

        const errorMessages = validate(schema, deduction)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) {
            return
        }
       
        saveData()
        setErrors(errors)

    }

    async function saveData() {
       
        if (!deduction.isDefaultValueEnabled) {
            deduction.defaultValue = 0;
        }

        if (!edit) {
            const values = await maptoFixedDeduction();
            const response = await services.saveData(deduction,values)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
        if (edit) {
            const values = await maptoFixedDeductionForEdit();
            const response = await services.editData(deduction,values)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
    }


    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState();
            setTimeout(() => {
                props.history.push({ pathname: '/deduction' })
            }, 1500);
        }
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setDeduction({
            ...deduction,
            deductionTemplateID: '0',
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            groupName: '',
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            factoryName: '',
            collectionPointID: 0,
            collectionCategoryMenuID: 0,
            collectionPointName: '',
            deductionTypeID: '0',
            deductionTypeName: '',
            applyMethodID: '0',
            collectionCategoryID: '',
            defaultValue: '',
            minimumValue: '',
            isActive: true,
            isDefaultValueEnabled: false,
            createdBy: '',
            createdDate: '',
            entityTypeID: 0,
            deductionOrder: '',
            deductionSequence:''
        })
    }

    async function setEntityTypeDropDown() {
        const result = await services.getEntityTypes()
        setEntityType(result)
    }

    async function setGroupDropDownData() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function setFactoryDropDownData() {
        const result = await services.getFactories()
        setFactoriesData(result)
    }

    async function setDeductionTypeDropDownData() {
        const result = await services.getDeductionTypes()
        setDeductionType(result)
    }


    async function setApplyMethodsData() {
        const result = await services.getApplyMethods()
        setApplyMethods(result)
    }

    function checkDeductionType(deduction){

        if(deduction.isFixed != true){
           return deduction.isDefaultValueEnabled = true;
        }
        else{
        return deduction.isDefaultValueEnabled = false;
        }
        

    }

    function renderDropDown(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items;
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function onClickCancel() {
        setErrors({});
        clearState();
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div>
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <PageHeader
                                title={pageProperties.title}
                                isButtonEnable={true}
                                buttonText="Back to Listing"
                                path="/deduction"
                            />
                        </div>
                        <form onSubmit={(e) => handleSave(e)}>

                            <div className="form-group row">

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        disabled={isDropdownDisable || !permissionList.isGroupFilterEnabled}
                                        name="groupID"
                                        value={deduction.groupID}
                                        onChange={(e) => handleGroupChange(e.target)}>
                                        <MenuItem value="0">--Select Group Name--</MenuItem>
                                        {renderDropDown(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">

                                    <InputLabel shrink id="operationEntityID">Operation Entity</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        disabled={isDropdownDisable || !permissionList.isOperationEntityFilterEnabled}
                                        name="operationEntityID"
                                        value={deduction.operationEntityID}
                                        onChange={(e) => handleOperationEntityChange(e.target)}>
                                        <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                        {renderDropDown(factoriesData)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>


                                <div className="col-md pb-1">

                                    <InputLabel shrink id="collectionPointID">Collection Point</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        disabled={isDropdownDisable}
                                        name="collectionPointID"
                                        value={deduction.collectionPointID}
                                        onChange={(e) => handleCollectionPointChange(e.target)}>
                                        <MenuItem key="0" value="0">--Select Collection Point--</MenuItem>
                                        {renderDropDown(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}

                                </div>
                            </div>
                            <div className="form-group row">
                            
                                <div className="col-md pb-1">

                                    <InputLabel shrink id="collectionCategoryMenuID">Collection Category Menu</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionCategoryMenuID"
                                        disabled={isDropdownDisable}
                                        name="collectionCategoryMenuID"
                                        value={deduction.collectionCategoryMenuID}
                                        onChange={(e) => handleCollectionCategoryMenuChange(e.target)}
                                        >
                                        <MenuItem key="0" value="0">--Collection Category Menu--</MenuItem>
                                        {renderDropDown(collectionCategoryMenus)}
                                    </Select>
                                    {errors["collectionCategoryMenuID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionCategoryMenuID"]}</FormHelperText>}

                                </div>
                                <div className="col-md pb-1">

                                    <InputLabel shrink id="deductionTypeID">Deduction Type</InputLabel>
                                    <Select
                                        fullWidth
                                        id="deductionTypeID"
                                        disabled={isDropdownDisable}
                                        name="deductionTypeID"
                                        value={deduction.deductionTypeID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Deduction Type--</MenuItem>
                                        {renderDropDown(deductionType)}
                                    </Select>
                                    {errors["deductionTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["deductionTypeID"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="applyMethodID">Apply method</InputLabel>
                                    <Select
                                        fullWidth
                                        id="applyMethodID"
                                        name="applyMethodID"
                                        value={deduction.applyMethodID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Apply Method--</MenuItem>
                                        {renderDropDown(applyMethods)}
                                    </Select>
                                    {errors["applyMethodID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["applyMethodID"]}</FormHelperText>}

                                </div>
                            </div>
                            <div className="form-group row">

                            <div className="col-md-2">
                                <label>Active</label>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <input
                                            className="mr-2"
                                            id="active"
                                            type="checkbox"
                                            switch="none"
                                            name="isActive"
                                            onChange={(e) => handleChange(e)}
                                            checked={deduction.isActive}
                                        />
                                        <label htmlFor="active" data-on-label="Yes"
                                            data-off-label="No"></label>
                                    </div>
                                </div>
                                   
                            </div>
                                
                                <div className="col-md">
                                        <TextField fullWidth label="Deduction Order"
                                            name="deductionOrder"
                                            id="deductionOrder"
                                            value={deduction.deductionOrder}
                                            type="number"
                                            onChange={(e) => handleChange(e)}
                                             />
                                            {errors["deductionOrder"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["deductionOrder"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md">
                                        <TextField fullWidth label="Deduction Sequence"
                                            name="deductionSequence"
                                            id="deductionSequence"
                                            value={deduction.deductionSequence}
                                            type="number"
                                            onChange={(e) => handleChange(e)} 
                                            />
                                            {errors["deductionSequence"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["deductionSequence"]}</FormHelperText>)}
                                    </div>
                            </div>
                          
                                
                            
                            <div className="form-group row">
                                <div className="col-md-2">
                                    <InputLabel shrink id="def">Is Fixed Deduction</InputLabel>
                                    <input
                                        className="mr-2"
                                        id="fixed"
                                        switch="none"
                                        type="checkbox"
                                        name="isFixed"
                                        onChange={(e) => handleSpecialDeductionChange(e)}
                                        checked={deduction.isFixed}
                                    />
                                    <label htmlFor="fixed" data-on-label="Yes"
                                        data-off-label="No"></label>
                                </div>
                                <div className="col-md-2">
                                <InputLabel shrink id="def">Default Deduction Enabled</InputLabel>
                                    <input
                                        className="mr-2"
                                        id="defaultValueEnabled"
                                        switch="none"
                                        type="checkbox"
                                        name="isDefaultValueEnabled"
                                        onChange={(e) => handleSpecialDeductionChange(e)}
                                        checked={deduction.isDefaultValueEnabled}
                                    />
                                    <label htmlFor="defaultValueEnabled" data-on-label="Yes"
                                        data-off-label="No"></label>
                                        </div>
                                        
                            </div>
                            {
                                deduction.isDefaultValueEnabled ?
                                    (
                                        <div className="form-group row">
                                            <div className="col-md-6">
                                                <InputLabel shrink id="defaultValue">Default Value</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    type="text"
                                                    className="form-control"
                                                    value="" name="defaultValue"
                                                    id="defaultValue"
                                                    onChange={(e) => handleChange(e)}
                                                    value={deduction.defaultValue}
                                                />
                                                {errors["defaultValue"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["defaultValue"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md-6">
                                                <InputLabel shrink id="minimumValue">Minimum Value</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    type="text"
                                                    className="form-control"
                                                    value="" name="minimumValue"
                                                    id="minimumValue"
                                                    onChange={(e) => handleChange(e)}
                                                    value={deduction.minimumValue}
                                                />
                                                {errors["minimumValue"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["minimumValue"]}</FormHelperText>}
                                            </div>

                                        </div>

                                    )
                                    : null
                            }
                            {
                                deduction.isFixed ?
                                    (
                                        <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <MaterialTable
                                        hidden={!deduction.isFixed}
                                        title="Deduction Types"
                                        fullWidth
                                        columns={state.columns}
                                        data={state.data}
                                        options={{showTitle:false,search:false}}
                                        editable={{
                                            onRowAdd: (newData) =>
                                                new Promise((resolve) => {
                                                    setTimeout(() => {
                                                        resolve();
                                                        setState((prevState) => {
                                                            const data = [...prevState.data];
                                                            data.push(newData);
                                                            return { ...prevState, data };
                                                        });
                                                    }, 600);
                                                }),
                                            onRowUpdate: (newData, oldData) =>
                                                new Promise((resolve) => {
                                                    setTimeout(() => {
                                                        resolve();
                                                        if (oldData) {
                                                            setState((prevState) => {
                                                                const data = [...prevState.data];
                                                                data[data.indexOf(oldData)] = newData;
                                                                return { ...prevState, data };
                                                            });
                                                        }
                                                    }, 600);
                                                }),
                                            onRowDelete: (oldData) =>
                                                new Promise((resolve) => {
                                                    setTimeout(() => {
                                                        resolve();
                                                       
                                                        setState((prevState) => {
                                                            const data = [...prevState.data];
                                                            data.splice(data.indexOf(oldData), 1);
                                                            return { ...prevState, data };
                                                        });
                                                        setDeletedValues((prevState) => {
                                                            const deleted = [...prevState.deleted];
                                                            deleted.push(oldData);
                                                            return { ...prevState, deleted };
                                                        });
                                                        
                                                    }, 600);
                                                }),
                                        }}
                                    />
                                </Grid>

                            </Grid>
                                    )
                                    : null
                            }

                            


                            <div className="card-footer">
                                <input
                                    disabled={validate(schema, deduction)}
                                    type="submit"
                                    className="btn btn-primary"
                                    value={pageProperties.buttonText}
                                    onClick={handleSave}
                                />
                                <input
                                    type="button"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={onClickCancel}
                                />

                            </div>
                        </form>
                        <MessageModal
                            hidden={messageModel.hidden}
                            messageType={messageModel.type}
                            messageDescription={messageModel.disciption}
                            clicked={modalDismissHandler}
                        />

                    </div>
                </div>

            </div>
        </Fragment>
    );
}